import headerMove from './header-move';
import styleComputed from './style-compute';
import dataHandle from './data-handle';
import edit from './edit';
import emptyTable from './empty-table';
import sort from './sort';
import filter from './filter';

export default [ headerMove, styleComputed, dataHandle, edit, emptyTable, sort, filter ];
